import rnCore from 'rhino/src/core/core.module';
import rnLocale from 'rhino/src/components/locale/locale.module';

import * as rnTutorial from './tutorial.service';

export default angular.module('rhino.components.tutorial', [
  rnCore,
  rnLocale,
])
  .factory(rnTutorial.name, rnTutorial.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/tutorial/tutorial.module.js